import { render, staticRenderFns } from "./GuideBookPaperCover.vue?vue&type=template&id=d39e8c06&scoped=true"
import script from "./GuideBookPaperCover.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperCover.vue?vue&type=script&lang=js"
import style0 from "./GuideBookPaperCover.vue?vue&type=style&index=0&id=d39e8c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39e8c06",
  null
  
)

export default component.exports